module.exports = __webpack_public_path__ + "img/bank_front.9af0540d.png";